import Memory from "./memory/Memory";
function App() {
  return <Memory></Memory>;
}

export default App;
